import { useSelector } from 'react-redux';
import { Backdrop, CircularProgress, Theme } from '@mui/material';
import { selectLoading } from 'main/store/common/selectors';

const ROOT_STYLE = {
    zIndex: (theme: Theme) => theme.zIndex.drawer + 10
}

export const ProgressBackdrop = () => {
    const loading = useSelector(selectLoading);

    return (
        <Backdrop open={loading > 0} sx={ROOT_STYLE}>
            <CircularProgress />
        </Backdrop>
    )
}
